<template>
    <div class="p-3" color="light">
        <div class="d-flex">
            <h5 class="subtitle-2">
                Live Rates configurations
            </h5>
            <v-btn class="mx-1 ml-3"x-small @click="showTestLiveRateModal=true" color="error">
                <span>
                    Test Liverate
                </span>
            </v-btn>
            <TestLiverateModal :payloads="liveRateTestPayload" :integration_id="integrationId" v-if="showTestLiveRateModal" @testLiveRateModalClose="showTestLiveRateModal = false" />
        </div>
        <v-form
            ref="metaForm"
            v-if="formItems"
            :disabled="isDisabled">
            <v-container fluid>
                <div
                    v-for="(item, index) in formItems"
                    :key="item.id">
                    <v-hover v-slot:default="{ hover }">
                        <v-row align="center" class="grey lighten-5 mb-3">
                            <v-col lg="3">
                                <v-text-field
                                    v-model="item.meta_key"
                                    type="text"
                                    label="Meta key"
                                    :rules="[v => !!v || 'Meta key is required']"
                                    :readonly="isDisabled">
                                </v-text-field>
                            </v-col>
                            <v-col lg="6">
                                <v-text-field
                                    v-model="item.meta_value"
                                    type="text"
                                    label="Meta value"
                                    :rules="[v => !!v || 'Meta value is required']"
                                    :readonly="isDisabled">
                                </v-text-field>
                            </v-col>

                            <v-col v-if="!isDisabled" sm="2" class="ml-auto text-right">
                                <span class="ic-remove clickable" @click="onRemove(item, index)">
                                    <i class="fa fa-times-circle fa-2x"></i>
                                </span>
                            </v-col>
                        </v-row>
                    </v-hover>
                </div>
            </v-container>
        </v-form>

        <div class="mt-3 d-flex" v-if="!isDisabled">
            <v-spacer></v-spacer>
            <v-btn class="mr-1" small @click="onAddMore">Add More</v-btn>
            <v-btn small color="primary" @click="onSubmit" :disabled="isSubmit">
                <span v-if="isSubmit">
                    <v-progress-circular
                      indeterminate
                        size="12"
                        width="2"
                      color="green darken-3">
                    </v-progress-circular>
                    saving
                </span>
                <span v-else>save</span>
            </v-btn>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../../../event-bus.js'
import TestLiverateModal from "../modals/TestLiverateModal";

export default {
    components: {TestLiverateModal},
    props: {
        integration_type_id: { type: Number, required:true },
        integrationMeta: { type: Array, default: [] },
        isDisabled: { type: Boolean, default: false }
    },

    data() {
        return {
            hideMeta: [
                'LIVE_RATE',
                'LIVE_RATE_QUOTE_SETTINGS',
                'LIVE_RATE_BOX_SETTINGS',
                'LIVE_RATE_UUID',
                'LIVE_RATE_ACCESS_TOKEN'],
            formItems: [],
            isSubmit: false,
            metas: [],
            
            showTestLiveRateModal: false,
            liveRateTestPayload: ""
        }
    },

    computed: {

        integrationId() {
            return this.$route.params.id
        }
    },

    mounted() {
        this.metas = [...this.integrationMeta]
        this.formItems = this.metas.filter(meta => !this.hideMeta.includes(meta.meta_key));

        this.getLiverateTestPayloadMeta();
    },

    methods: {
        onRemove(itemMeta, index) {
            this.formItems.splice(index, 1)
            if (Number.isInteger(itemMeta.id)) {
                this.$http
                    .delete('/api/integrationmetas/' + itemMeta.id)
                    .then(() => {
                        EventBus.$emit('show-success', 'Successfully deleted live rate configuration.');
                    })
                    .catch(err => {
                        EventBus.$emit('show-error', err)
                    })
            }
        },

        onAddMore() {
            this.formItems.push({
                meta_key: '',
                meta_value: ''
            })
        },

        async onSubmit(e) {
            e.preventDefault();

            // validate
            if (this.formItems == null || this.formItems.length == 0) {
                return
            }

            this.isSubmit = true

            if (this.$refs.metaForm.validate()) {
                try {
                    // lets map the data for live rates
                    let dataItems = this.formItems.map(meta => {
                        let meta_key = meta.meta_key.indexOf('LIVE_RATE') >= 0 ? meta.meta_key : 'LIVE_RATE_' + meta.meta_key
                        return {
                            id: meta.id,
                            meta_key: meta_key,
                            meta_value: meta.meta_value,
                            integration_id: this.integrationId
                        }
                    })


                    const { data } = await this.$http.post('/api/integrationmetas/bulk', dataItems)
                    EventBus.$emit('show-success', 'Successfully saved liverates configurations.')
                    this.prepareMapItems(data)
                    this.isSubmit = false
                } catch (err) {
                    EventBus.$emit('show-error', err)
                }
            } else {
                console.log("not valid");
            }
        },

        async onActivate(status) {
            // find the real liverate
            let liverate = this.integrationMeta.find(meta => (meta.meta_key == 'LIVE_RATE'))
            try {
                this.isSubmit = true
                let dataItem = liverate ? liverate : { integration_id: this.integrationId , meta_key: 'LIVE_RATE' }
                dataItem.meta_value = status ? 'TRUE' : 'FALSE'

                let { data } = await this.$http.post('/api/integrationmetas/bulk', [dataItem])

                EventBus.$emit('show-success', 'Successfully activated liverates configurations.')
                this.isSubmit = false

                if (typeof data.message !== 'undefined') {
                    EventBus.$emit('show-error', data.message)
                }
                else {
                    if (!status) {
                        EventBus.$emit('show-success', 'Successfully deactivated liverates configurations.')
                    } else {
                        EventBus.$emit('show-success', 'Successfully activated liverates configurations.')
                    }
                }

            } catch (err) {
                EventBus.$emit('show-error', err)
            }
        },

        prepareMapItems(data) {
            if (
                data.data &&
                data.data.attributes &&
                data.data.attributes.metas
            ) {
                this.metas = data.data.attributes.metas
                this.formItems = this.metas.filter(meta => {
                    return meta.meta_key.indexOf('LIVE_RATE') >= 0 && !this.hideMeta.includes(meta.meta_key)
                })
                this.getLiverateTestPayloadMeta()
            }
        },

        getLiverateTestPayloadMeta()
        { 
            this.liveRateTestPayload = "";
            const liveRateTestPayloadObject = this.formItems.find(obj => obj.meta_key === 'LIVE_RATE_TEST_PAYLOAD');
            // Check if the object is found and has the meta_value property
            if (liveRateTestPayloadObject && liveRateTestPayloadObject.meta_value) {
                this.liveRateTestPayload = liveRateTestPayloadObject.meta_value
            } else {
                const fileName = `payload_${this.integration_type_id}.json`;
                // Dynamically import the JSON file
                import(`../../../data/liverate/payloads/${fileName}`).then((jsonModule) => {
                    this.liveRateTestPayload = JSON.stringify(jsonModule.default);
                }).catch((error) => {
                    console.error(`Failed to import JSON file: ${fileName}`, error);
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .liverate-switcher {
        margin-top: -1.5rem;
    }

    .v-label {
        margin-bottom: 0;
    }
</style>